import { PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

export const Container = styled.div`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
  display: flex;
  flex-direction: column;  
  justify-content: space-between;
`
export const PressableContainer = styled.button<PropsWithChildren<object>>`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: none;
  cursor: pointer;
  background: none;
`

export const OptionLabel = styled.span`
  ${({ theme }) => css`
    font-size: 18px;
    color: ${theme.colors.text};
  `}
`

export const SelectedOptionLabel = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    color: ${theme.colors.textDisabled};
    padding-top: 10px;
  `}
`

export const FilterOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const BottomContainer = styled.div`
  padding: 0px 15px 15px 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: ${({ theme }) => `${theme.colors.background}`};
`
